import { Produkt, PreislistenKatalog } from "./produkt";
import { Column, Option } from "./option";
import { OptionPriceInformation } from "./optionPriceInformation";
import { OptionGroup } from "./optionGroup";
import { OptionFormUiElementsData } from "./optionFormUiElementsData";

export class OptionFormData {
  //  both
  id = "";
  optionName = "";
  optionType: string;
  sortId = 0;
  optionPriceInformation: OptionPriceInformation[];
  preislistenKatalog: PreislistenKatalog;
  optionGroup = <OptionGroup>{};
  associatedProducts: Produkt[];

  //  DE
  optionPosition: string;
  //  only on certain Option Types
  optionUnitId?: string;
  fixedValue: number;
  //  US
  invoiceCategory: string;
  glCode: string;
  quantityType: string;
  requiredQuantityType: string;
  costsPer: string;
  ancillaryCode: string;

  dependentOptions: Option[];

  // ui related elements
  uiElementsData: OptionFormUiElementsData;
  hideInFrontend: boolean;
  covers: boolean;

  // TODO: Delete in future after Option importer feature
  optionPriceInformationColumnNames: string[] = [];

  // gets replaced with
  columns: Column[] = [];

  constructor(option?: Option) {
    if (option) {
      this.optionName = option.optionName + "";
      this.optionType = option.optionType + "";
      if (option.optionPosition) this.optionPosition = option.optionPosition;
      this.sortId = option.sortId;
      if (option.optionPriceInformation)
        this.optionPriceInformation = option.optionPriceInformation;
      if (option.preislistenKatalog)
        this.preislistenKatalog = option.preislistenKatalog;
      if (option.optionUnit && option.optionUnit.id)
        this.optionUnitId = option.optionUnit.id;
      if (option.optionGroup) this.optionGroup = option.optionGroup;
      if (option.fixedValue) this.fixedValue = option.fixedValue;
      this.id = option.id;
      this.associatedProducts = [];
      this.invoiceCategory = option.invoiceCategory;
      this.glCode = option.glCode;
      this.requiredQuantityType = option.requiredQuantityType;
      this.quantityType = option.quantityType;
      this.costsPer = option.costsPer;
      if (option.cartonColumnNames) {
        this.optionPriceInformationColumnNames = option.cartonColumnNames;
      }
      if (option.columns) {
        this.columns = option.columns;
        this.transformValues();
      }
      if (option.ancillaryCode) {
        this.ancillaryCode = option.ancillaryCode;
      }
      this.associatedProducts = [];
      this.uiElementsData = new OptionFormUiElementsData();
      this.hideInFrontend = option.hideInFrontend;
      this.covers = option.covers;
    } else {
      this.uiElementsData = new OptionFormUiElementsData();
    }
  }

  // This is needed for Column Positioning
  // The values inside the Array can not be displayed inside a Data Grid
  // So the Array index-values are being transformed into single fields that are
  // used as DataFields
  // On Saving the Data, the fields are Transformed back to an Array and parsed into the request
  transformValues() {
    this.optionPriceInformation?.forEach((price) => {
      this.columns.forEach((col, index) => {
        price[`column${index}`] = price.values?.[index];
      });
    });
  }
}
